import { CircularProgress } from "@mui/material";
import type { FC } from "react";
import { useSupabaseLoader } from "../../../../../server/supabase/hooks";
import { SupabaseCustomEmojiService } from "../../../../slack/server/slack-supabase-service";

export const CustomEmoji: FC<{ name: string }> = ({ name }) => {
  const { data, loading } = useSupabaseLoader(
    async ({ supabase, account_id }) => {
      const { data: emoji } = await new SupabaseCustomEmojiService(supabase).getByName(
        account_id,
        name,
      );

      return emoji;
    },
    [name],
  );

  if (loading) return <CircularProgress sx={{ width: "1em", height: "1em" }} />;

  return (
    <img
      src={data?.url}
      alt={`:${name}:`}
      title={name}
      style={{
        width: "1em",
        height: "1em",
        objectFit: "contain",
        verticalAlign: "middle",
      }}
    />
  );
};
